import React from "react";
import { IonModal } from "@ionic/react";
import PinEditor from "../PinEditor";
import { useTracked } from "../../state";
import { AuthMode } from "@ionic-enterprise/identity-vault";

const PinEditorModal: React.FC = () => {
  const [state, dispatch] = useTracked();

  const onDidDismiss = async () => {
    if (state.authMode !== AuthMode.PasscodeOnly) {
      localStorage.setItem("isOnlyPin", "false");
    }
    dispatch({ type: "hideApplicationsPIN" });
  };

  return (
    <IonModal isOpen={state.showPinDialog} onDidDismiss={onDidDismiss}>
      <PinEditor setPasscode={state.setApplicationPin}></PinEditor>
    </IonModal>
  );
};

export default PinEditorModal;
